export const MESSAGE_TYPE = {
  SET_FULL_SCREEN: 'setFullScreen',
  SET_IFRAME_MODE: 'setIframeMode',
  SET_IFRAME_HEIGHT: 'setIframeHeight',
  NAVIGATE_TO: 'navigateTo',
  PREVIEW_TEMPLATE: 'previewTemplate',
  TEMPLATE_SAVE: 'onTemplateSave',
  HOME_CLICKED: 'homeClicked',
  OPEN_INTEGRATION_WELCOME_DIALOG: 'openIntegrationWelcomeDialog',
  START_FREE_TRIAL: 'startFreeTrial',
  READY: 'initialElementReady',
  ROOT_COMPONENT_MOUNTED: 'rootComponentMounted',
  ROOT_COMPONENT_WILL_UNMOUNT: 'rootComponentWillUnmounted',
};

export const IFRAME_MODE = {
  NONE: 0,
  VISIBLE: 1,
};
